






















































import draggable from '@/mixins/draggable';
import { Question } from '@/models/configurator/question';
import { ErrorManager } from '@/models/error';
import { compareOrder } from '@/utils/helpers';
import mixins from '@/utils/mixins';
import { cloneDeep } from 'lodash';
import { PropType } from 'vue';
import VueDraggable from 'vuedraggable';
import { mapActions } from 'vuex';
import ErrorAlert from '../common/ErrorAlert.vue';
import ALDialog from './Dialog/ALDialog.vue';
import { AxiosError } from 'axios';

export default mixins(draggable).extend({
  components: {
    VueDraggable,
    ALDialog,
    ErrorAlert
  },

  props: {
    items: Array as PropType<any[]>
  },

  data() {
    return {
      dialog: false,
      loading: false,
      list: cloneDeep(this.items),
      errorMessage: '',
      detailErrorMessage: ''
    };
  },

  computed: {
    computedStates(): any[] {
      return this.items;
    }
  },

  watch: {
    dialog(val: boolean) {
      if (val) {
        this.list = cloneDeep(this.items);
      }
    }
  },

  methods: {
    ...mapActions('configuratorQuestion', ['updateQuestionOrder']),

    clearAllErrors() {
      this.errorMessage = '';
      this.detailErrorMessage = '';
    },

    async updateColumn() {
      this.clearAllErrors();
      this.loading = true;
      const questions: Question[] = this.list.map(function(
        question: Question,
        index: number
      ) {
        question.order = index + 1;
        return question;
      });

      const difference = questions.filter(compareOrder(this.items));

      try {
        // TODO: We should re-write this component to do the update function inside this component
        // and not have this functionality passed in. This will allow us to properly handle errors
        let itemsProcessed = 0;
        difference.forEach(async question => {
          await this.updateQuestionOrder({
            module: question.module,
            id: question.id,
            order: question.order
          });
          itemsProcessed++;
          if (itemsProcessed === difference.length) {
            this.loading = false;
            this.close();
          }
        });
      } catch (err) {
        const error = err as AxiosError;
        if (error.response) {
          // client received an error response that falls out of range 2xx

          if (error.response.data.detail) {
            this.detailErrorMessage = error.response.data.detail;
          }
        }
        this.errorMessage = ErrorManager.extractApiError(error);
      } finally {
        this.loading = false;
      }
    },

    sort() {
      this.list = this.list.sort((a, b) => a.order - b.order);
    },

    close() {
      this.dialog = false;
    }
  }
});
